import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { TargetingListListApi } from '../../../api/targeting/model/targeting-list-list-api.model';
import { LeftSidebarListItemConvertableModel } from '../../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { LeftSidebarListItemButton } from '../../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItem } from '../../../Common/Layout/models/left-sidebar-list-item.model';
import { ActionsEnum } from '../../../Common/Basic/enums/actions.enum';

/**
 * Represents the list item data structure for TargetingLists,
 * used in LHP and other locations that require count information.
 */
export class TargetingListList implements AuditableModel, LeftSidebarListItemConvertableModel {

    static readonly allPrivateContactsId = -1;

    id?: number;
    name?: string;

    count?: number;

    contactCount?: number;
    outletCount?: number;

    hasContacts: boolean;
    hasOutlets: boolean;

    createdByUserId?: number;
    createdDate?: Date;

    modifiedByUserId?: number;
    modifiedDate?: Date;

    hidden?: boolean;
    groupId: number;
    isFavorite: boolean;

    constructor(apiModel?: TargetingListListApi) {
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: TargetingListListApi) {
        this.id = +apiModel.id;
        this.name = apiModel.name;
        this.count = apiModel.contactCount + apiModel.outletCount;
        this.contactCount = apiModel.contactCount;
        this.outletCount = apiModel.outletCount;
        this.hasContacts = apiModel.contactCount > 0;
        this.hasOutlets = apiModel.outletCount > 0;
        this.createdByUserId = apiModel.createdUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.modifiedByUserId = apiModel.modifiedUserId;
        this.modifiedDate = apiModel.modifiedDate ? new Date(apiModel.modifiedDate) : null;
        this.hidden = apiModel.hidden;
        this.groupId = apiModel.displayGroupId;
        this.isFavorite = apiModel.isFavorited;
    }

    constructDefault() {
        this.isFavorite = false;
    }

    toLeftSidebarListItem(buttons?: LeftSidebarListItemButton[]): LeftSidebarListItem {
        if (buttons) {
            if (this.hidden) {
                buttons = buttons.filter(button => button.key !== ActionsEnum.hide);
            } else {
                buttons = buttons.filter(button => button.key !== ActionsEnum.show);
            }

            if (this.isFavorite) {
                buttons = buttons.filter(button => button.key !== ActionsEnum.favorite);
            } else {
                buttons = buttons.filter(button => button.key !== ActionsEnum.unfavorite);
            }
        }

        return {
            label: this.name,
            value: this.id,
            buttons: buttons,
            status: this.count,
            groupId: this.groupId,
            isFavorite: this.isFavorite
        };
    }
}
